/* RESPONSIBLE TEAM: team-workflows */
import Step, { IsCustomerFacing } from 'embercom/models/operator/visual-builder/step';
import { buildValidations, validator } from 'ember-cp-validations';
import type Store from '@ember-data/store';
import type ConnectionPoint from '../connection-point';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';

const Validations = buildValidations({
  outwardConnectionPoints: [validator('has-many')],
});

export default class EmailOtp extends Step.extend(Validations) {
  // No additional attrs needed - uses user's email from conversation automatically

  get supportedChannels() {
    return SUPPORTED_CHANNELS.emailOtp;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation, TargetContext.CustomerTicket];
  }

  static get requiredBillingFeature() {
    return 'workflows_core_billing_feature';
  }

  static get canBeCustomerFacing(): IsCustomerFacing {
    return IsCustomerFacing.Yes; // OTP collection is always customer-facing
  }

  get hasUnsavedChanges() {
    return (
      this.hasDirtyAttributes ||
      (this.outwardConnectionPoints?.toArray() ?? []).some(
        (cp: ConnectionPoint) => cp.hasUnsavedChanges,
      )
    );
  }

  static createNewStep(store: Store): EmailOtp {
    let outwardConnectionPoints = [
      store.createRecord('operator/visual-builder/connection-point', { type: 'fallback' }),
    ] as ConnectionPoint[];

    return store.createRecord('operator/visual-builder/step/email-otp', {
      outwardConnectionPoints,
      type: 'operator/visual-builder/step/email-otp',
    });
  }
}
